export default __webpack_public_path__ + "static/media/bg4.f8a45457.png";